import "./Footer.scss";

import HeroStar from "../../assets/images/hero-star.svg";

import FooterBg from "../../assets/images/footer-bg.png";
import DesktopOval4 from "../../assets/images/decoration/desktop-oval-4.svg";

export default function Footer() {
	const handleScroll = (e) => {
		e.preventDefault(); // Prevent default anchor behavior

		try {
			const target = e.target.getAttribute("href");
			const targetElement = document.querySelector(target);
			const headerHeight = document.querySelector(".header").offsetHeight;

			const yOffset = -headerHeight; // Negative offset to account for the header
			const yPosition =
				targetElement.getBoundingClientRect().top +
				window.pageYOffset +
				yOffset;

			window.scrollTo({ top: yPosition, behavior: "smooth" });
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<div className="footer" id="footer">
			<img
				className="decoration footer-bg"
				src={FooterBg}
				alt="Footer Background"
			/>
			<img
				className="decoration desktop-light-1"
				src={DesktopOval4}
				alt="Desktop Oval 4"
			/>

			<div className="footer-content-wrapper content-wrapper-lg">
				<div className="footer-content">
					<div className="footer-left">
						<h5 className="footer-title">
							<span>ChainCompute</span>
							<span className="highlight">
								AI
								<img
									className="hero-star"
									src={HeroStar}
									alt="Hero Star"
								/>
							</span>
						</h5>

						<div className="footer-sub-title">
							Empowering Progress through AI.
						</div>

						<div className="footer-desc">
							We harness AI to simplify complexities, boost
							efficiency, and unlock opportunities across
							industries, blending technology with human
							ingenuity.
						</div>
					</div>

					<div className="footer-right">
						<nav className="footer-nav">
							<ul>
								<li>
									<a href="#heading" onClick={handleScroll}>
										Home
									</a>
								</li>
								<li>
									<a
										href="#our-features"
										onClick={handleScroll}
									>
										About
									</a>
								</li>
								<li>
									<a href="#roadmap" onClick={handleScroll}>
										RoadMap
									</a>
								</li>
								<li>
									<a
										href="#contact-us"
										onClick={handleScroll}
									>
										Community
									</a>
								</li>
							</ul>
						</nav>

						<div className="footer-email">
							<div className="email-btn">
								<div className="email-btn-left">
									chaincompute@gmail.com
								</div>
								<a
									className="email-btn-right"
									href="mailto:chaincompute@gmail.com"
								>
									Contact
								</a>
							</div>
						</div>
					</div>
				</div>

				<div className="footer-copyright">
					© ChainCompute AI - 2025 All Rights Reserved
				</div>
			</div>
		</div>
	);
}
